<script lang="ts">
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";
  import { getOrdinal } from "$lib/common/helpers/ordinalFormat";
  import { formatDate } from "$lib/common/helpers/date";
  import { project } from "$lib/services/store";
  import { getTranslatedText } from "$lib/data/translations";
  import { onMount } from "svelte";

  export let tournamentData: any;
  export let playerPosition: number;
  export let finalScore: number | string;
  const tournamentsRoute: string = $project.settings.tournamentsUrl ?? "turneringar";

  const lang = $project.settings.lang ?? "en";

  let message: { title: string; message: string } | null = null;

  const getMessage = () => {
    if (!tournamentData || playerPosition === null) {
      return null;
    }

    const isDailySpins = tournamentData.isDailyXSpinsTournament;
    const hasRemainingDailySpins = tournamentData.remainingSpinMadeForToday > 0;
    const displayScore = tournamentData.playerScoreNoPrefix || finalScore;

    if (isDailySpins && !hasRemainingDailySpins) {
      return {
        title: getTranslatedText("End spinning! Play again TOMORROW"),
        message: getTranslatedText("You currently hold [position] place.", {
          position: getOrdinal(playerPosition, lang),
        }),
      };
    }

    const hasPrize =
      tournamentData.liveScoreboardHighlight?.some?.(
        (player: any) => player.position === playerPosition && player.displayPrizes,
      ) ?? false;

    if (playerPosition === 1) {
      return {
        title: getTranslatedText("Congratulations, you have [position] place!", {
          position: getOrdinal(playerPosition, lang),
        }),
        message: getTranslatedText("Your score: [score]\nThe tournament ends on [endDate] - Good luck!", {
          score: displayScore,
          endDate: formatDate(tournamentData.endDate, "display"),
        }),
      };
    }

    if (hasPrize) {
      return {
        title: getTranslatedText("Congratulations, you have [position] place!", {
          position: getOrdinal(playerPosition, lang),
        }),
        message: getTranslatedText("Your score: [score]", {
          score: displayScore,
        }),
      };
    }

    return {
      title: getTranslatedText("End of tournament!"),
      message: getTranslatedText("Your points: [score]", {
        score: displayScore,
      }),
    };
  };

  $: if (tournamentData && playerPosition !== null) {
    message = getMessage();
  }

  onMount(() => {
    message = getMessage();
  });
</script>

<div class="completion-overlay">
  <div class="overlay-content">
    {#if message}
      <h2>{message.title}</h2>
      <p class="message">{message.message}</p>
    {/if}
    <a href={`/` + tournamentsRoute} class="back-button">
      <Translate text="Back to tournaments" />
    </a>
  </div>
</div>

<style>
  .completion-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .overlay-content {
    background: #282828;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    min-width: 300px;
  }

  .message {
    font-size: 1.2rem;
    margin: 0;
    white-space: pre-line;
  }

  h2 {
    margin: 0;
    color: #ffcf3a;
    font-size: 1.5rem;
  }

  .back-button {
    display: inline-block;
    background: #65c82d;
    color: white;
    padding: 0.8rem 1.5rem;
    border-radius: 4px;
    text-decoration: none;
    font-weight: bold;
    margin-top: 1rem;
    transition: background-color 0.3s;
  }

  .back-button:hover {
    background: #54a725;
  }
</style>
